import CryptoJS from 'crypto-js';

// --- Extra part to hide the key string ---
var encodedSecret = import.meta.env.VITE_SECRET_KEY;
// This converts the Base64 string back to the original key format
var secretkey = CryptoJS.enc.Base64.parse(encodedSecret).toString(CryptoJS.enc.Utf8);
//console.log("secretkey", secretkey)
// -----------------------------------------

var ivString = '123456789ABCDEFG';
var key = CryptoJS.enc.Utf8.parse(secretkey);
var iv = CryptoJS.enc.Utf8.parse(ivString);

/*-- Encryption --*/
export const encrypt = (plainString: string) => {
  var cipherText = CryptoJS.AES.encrypt(plainString, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
  // console.log(cipherText);
  return cipherText;
};

/*-- Decryption --*/
export const decrypt = (encryptString: string) => {
  var decrypted = CryptoJS.AES.decrypt(encryptString, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  // console.log(decrypted.toString(CryptoJS.enc.Utf8));
  return decrypted.toString(CryptoJS.enc.Utf8);
};
